import { Button, Carousel, message } from "antd";
import { useEffect, useState } from "react";
import { getHighlightSections } from "../../apis/highLightSectionsApi";
import Title from "antd/es/typography/Title";

const HighlightSection = () => {
    const [highlightSections, setHighlightSections] = useState([]);

    useEffect(() => {
        const fetchHighlightSections = async () => {
            try {
                const today = new Date();
                const response = await getHighlightSections(today, today);
                setHighlightSections(response.data);
            } catch (error) {
                message.error("Error al cargar las secciones destacadas");
            }
        }
        fetchHighlightSections();
    }, []);

    if (!highlightSections || highlightSections.length === 0) return null;

    return (
        <>
            <Title level={4} className='text-center'>Destacados</Title>
            <div className="themed-block mx-auto mt-2 mb-5" style={{width: "42.19vh", height: "75vh", overflow: 'visible', position: 'relative'}}>
                <style>{`.highlight-carousel .slick-list, .highlight-carousel .slick-track { overflow: hidden !important; }`}</style>
                <Carousel
                    className="highlight-carousel"
                    arrows={highlightSections.length > 1}
                    dots={false}
                    autoplay
                    >
                    {highlightSections.map((highlightSection, index) => (
                        <div key={index}>
                            <div style={{width: "42.19vh", height: "75vh", position: "relative", overflow: "hidden"}}>
                                {highlightSection.type === 'image' ? (
                                    <img
                                    src={`/img/highlightSections/${highlightSection.asset}`}
                                    alt=""
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block"
                                    }}
                                    />
                                ) : highlightSection.type === 'video' ? (
                                    <video
                                    autoPlay
                                    muted
                                    loop
                                    preload="auto"
                                    className="portrait-video landingVideo"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block"
                                    }}
                                    src={`/video/highlightSections/${highlightSection.asset}`}
                                    />
                                ) : null}
                                {highlightSection.link && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: '10px',
                                            left: 0,
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            paddingBottom: '10px',
                                            zIndex: 1000,
                                        }}
                                    >
                                        <a href={highlightSection.link}>
                                            <Button className="btn themed-btn" style={{lineHeight: 0}}>Ver más</Button>
                                        </a>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </>
    );
};

export default HighlightSection;
